import { DynamicIframesFormService } from './shared/dynamic-iframes.form.service';
import { DynamicIframesDataService } from './shared/dynamic-iframes.data.service';
import { DynamicIframesConfigService } from './shared/dynamic-iframes.config.service';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { AuthenticationService, Logger } from '@app/core';
import { BaseControl, ConfirmComponent, Const, Iframe } from '@app/shared';
import { ToastrService } from 'ngx-toastr';


const log = new Logger('CreationDynamicComponentComponent');

@Component({
  selector: 'iw-dynamic-iframes',
  templateUrl: './dynamic-iframes.component.html',
  styleUrls: ['./dynamic-iframes.component.scss'],
  providers: [
    DynamicIframesDataService,
    DynamicIframesFormService
  ]
})
export class DynamicIframesComponent implements OnInit {
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  settings = {};
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    review: false,
    created: false,
    update: false,
    delete: false
  };
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Define si el iframe seleccionado esta en edicion
  iframeEdit = true;
  // define el iframe seleccionado
  iframeSelected: Iframe;
  // Datos para llenar la tabla
  @Input() sourceData: Iframe[] = [];
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Lista de los iframe
  iframes: Iframe[] = [];

  constructor(
    private toastr: ToastrService,
    private as: AuthenticationService,
    private dds: DynamicIframesDataService,
    private dfs: DynamicIframesFormService
  ) { }

  ngOnInit() {// Determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationIframes,
      Const.types_action_permissions.created
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationIframes,
      Const.types_action_permissions.update
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationIframes,
      Const.types_action_permissions.delete
    );
    const configTable = new DynamicIframesConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.data);
    });
    this.loadingIframes();
  }


  /**
   * metodo que consulta todos los registros de iframes
   *
   * @memberof DynamicIframesComponent
   */
  loadingIframes(){
    this.dds.getIframes().subscribe(res => {
      this.sourceData = res;
    });
  }


  
  /**
   * Define las acciones ha realizar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof DynamicIframesComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        if (this.activateAction.created) {
          this.formOpen = true;
          this.iframeEdit = false;
          this.actionForm = 'Agregar';
          this.controls = this.dfs.getFormIframe();
        } else {
          this.toastr.error('Usted no posee permisos para agregar iframes',
            'Permiso denegado');
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          this.formOpen = true;
          this.iframeEdit = true;
          this.actionForm = 'Modificar';
          this.iframeSelected = data;
          this.controls = this.dfs.getFormIframe(this.iframeSelected);
        } else {
          this.toastr.error('Usted no posee permisos para modificar el iframe',
            'Permiso denegado');
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.iframeSelected = data;
          this.question = '¿Realmente desea eliminar el iframe?';
          this.confirm.open();
        } else {
          this.toastr.error('Usted no posee permisos para eliminar el iframe',
            'Permiso denegado');
        }
        break;
    }
  }

  
  /**
   * Metodo que organiza el iframe y lo midifica
   *
   * @param {*} data
   * @memberof DynamicIframesComponent
   */
  sended(data: any) {
    const ifrm: Iframe = {
      nombre: data.nombre,
      url: data.url,
      propiedades: data && data.propiedades ? data.propiedades : null,
      activo: data.activo,
    };
    if (this.iframeEdit) {
      this.dds.updateIframe(this.iframeSelected.id, ifrm).then(resp => {
        if (resp) {
          this.closeForm();
          this.loadingIframes();
        }
      });
    } else {
      this.dds.cretateIframe(ifrm).then(resp => {
        if (resp) {
          this.closeForm();
          this.loadingIframes();
        }
      });
    }
  }


  /**
   * Elimina un iframe
   *
   * @private
   * @memberof DynamicIframesComponent
   */
  private deleteIframe() {
    this.dds.deleteIframe(this.iframeSelected.id).then(() => {
      this.closeForm();
      this.loadingIframes();
    }).catch(() => {
      this.closeForm();
    });
  }


  /**
   * Cierra la vista del formulario de creacion o edicion
   *
   * @memberof DynamicIframesComponent
   */
  closeForm() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.iframeEdit = false;
    this.iframeSelected = null;
  }


  
  /**
   * Activa modal de confirmación
   *
   * @param {boolean} res
   * @memberof DynamicIframesComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteIframe();
    }
    this.question = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/iframe-management/dynamic-iframes-component/dynamic-iframes.component.ts